import React,{useContext} from 'react'
import "../App.css"
import fileDownload from 'js-file-download';
import axios from 'axios';
import { Context } from '../context/Context';
import {commonText as text} from "../Database/Database";


export default function PopupModal({ imgUrl, showModal, setShowModal }) {

  const {theme,lang} = useContext(Context);

  console.log("imgUrl =>", imgUrl);
  console.log("showModal =>", showModal);
  console.log("setShowModal =>", setShowModal)
  const closeIcon = require("../assets/red/close_icon.png") //red


  const handleDownload = (url, filename) => {
    axios.get(url, {
      responseType: 'blob',
    })
    .then((res) => {
      fileDownload(res.data, filename)
    })
  }
   

  return (
    <div className={`App-width ${theme === "red" ? "bg-redThemePrimaryRedColor border border-gray-600 ": "bg-white"} px-2`}>
      <div className=''>
        <div className='w-full flex justify-between '>
          <div className={` ${theme === "red" ? " p-1 ml-auto mr-0" : "  bg-darkGrey text-orangeBtn mt-1 px-1 py-1 border ml-auto mr-2 mb-1"}  rounded-full`} onClick={ () => setShowModal(false)}>{<img style={{width: "1.3rem"}} src={closeIcon} /> }</div> 
        </div>
        <div className='w-full'>
          <img className='w-full' style={{height : "30rem"}} src={imgUrl} />
        </div>
      </div>
      <div className={theme == "red" ?  " bg-white py-2":'my-2 py-2 pb-4 bg-white'} onClick={() => {
            handleDownload(imgUrl,"donwload");
          }}><span className={theme === "red" ? "bg-redThemePrimaryRedColor px-6 py-1 font-bold text-2xl text-white" : "rounded border py-2 px-4 bg-yellow-400 "}>{text.save[lang]}</span></div>
    </div>
  )
}
